import { AutogenModelDrsPayrateGroup, AutogenRowDrsPayrateGroup } from "./autogen/AutogenModelDrsPayrateGroup";

export class ModelDrsPayrateGroup extends AutogenModelDrsPayrateGroup<RowDrsPayrateGroup> {
	constructor() {
		super(RowDrsPayrateGroup);
	}
}

export class RowDrsPayrateGroup extends AutogenRowDrsPayrateGroup {
}